import {Component, OnDestroy, OnInit} from '@angular/core';
import {SharedValueService} from './services/shared-value.service';
import {UserSetting} from './models/user-setting';
import {NavigationEnd, Router} from '@angular/router';
import {AuthenticationService} from './services/authentication.service';
import {RoomService} from './services/room.service';
import {GroupService} from './services/group.service';
import {DialogService} from './services/dialog.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  preserveWhitespaces: false
})
export class AppComponent implements OnInit, OnDestroy {
  userSession: UserSetting;
  url: string;
  dialog: any;
  constructor(private sharedValueService: SharedValueService,
              private authService: AuthenticationService,
              private roomService: RoomService,
              private groupService: GroupService,
              private router: Router,
              private dialogService: DialogService) {
    this.dialog = dialogService;
    router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
      }
      if (sharedValueService.isLoggedIn()) {
        this.userSession = sharedValueService.getUserSession();

        const accessToken = this.authService.getCurrentToken();
        if (accessToken && this.userSession) {
          const authentication = this.authService.toAuthenticationModel(accessToken);
          if (authentication.id !== this.userSession.id) {
            this.router.navigated = false;
            location.href = this.url;
          }
        }
      }

    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {

  }
}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts